import { withTheme } from "@rneui/themed";
import React from "react";
import { StyleSheet } from "react-native";
import { ShareItemButton } from "@annunciate/ui/dist/components/shared/ShareItemButton";
import { View } from "../elements";
import { Broadcast, EllipsisButton } from "./";
export const UnthemedTopButtonBar = ({ content, iconStyle, containerStyle, }) => {
    return (React.createElement(View, { style: styles.container },
        React.createElement(Broadcast, { iconStyle: iconStyle, buttonStyle: styles.button }),
        React.createElement(ShareItemButton, { item: content, iconStyle: iconStyle, buttonStyle: styles.button }),
        React.createElement(EllipsisButton, { item: content, iconStyle: iconStyle, buttonStyle: styles.button })));
};
const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        flexShrink: 1,
    },
    button: {
        paddingVertical: 0,
        marginVertical: 0,
        paddingHorizontal: 0,
        marginHorizontal: 0,
    },
});
export const TopButtonBar = withTheme(UnthemedTopButtonBar, "ButtonBar");
//# sourceMappingURL=TopButtonBar.js.map